<template>
<div>
  <v-text-field
      v-model.number="localDiscount"
      type="text" background-color="white" hide-details outlined dense class="_inside-input-wrapper"
  >
    <template v-slot:append>
      <v-select
          :items="['₽','%']"
          v-model="discountType"
          hide-details dense
          @change="prepare()"
      ></v-select>
    </template>
  </v-text-field>
</div>
</template>

<script>
export default {
  props: [
    'visitServiceId', 'price', 'discount', 'count'
  ],
  data:()=>({
    discountType: '%',
    localDiscountNumber:null,
    localDiscountPercent:null,
  }),
  mounted(){
    this.prepare()
  },
  watch:{
    price() {
      this.prepare();
    },
    discount() {
      this.prepare();
    },
    count() {
      this.prepare();
    }
  },
  computed: {
    localDiscount:{
      get(){
        return this.discountType === '%' ? this.localDiscountPercent : this.localDiscountNumber
      },
      set(v){
        this.$emit('inputWait');
        this.$tools.debounce(()=>{
          let discount = 0;
          if(this.discountType === '%'){
            discount = ((this.price*this.count)/100)*parseFloat(v);
          } else {
            discount = v;
          }
          this.$emit('update:discount', discount.toFixed(0));
        },1000, 'visitServiceIdDiscount'+this.visitServiceId);
      }
    }
  },
  methods: {
    prepare(){
      if(
        !this.$tools.isEmpty(this.price) &&
        !this.$tools.isEmpty(this.discount) &&
        !this.$tools.isEmpty(this.count) &&
        parseFloat(this.discount)!==parseFloat(this.localDiscount)
      ){
        this.localDiscountPercent = ((this.discount/(this.price*this.count))*100).toFixed(0);
        this.localDiscountNumber = parseFloat(this.discount).toFixed(0);
      }
    },
  }
}
</script>